export default "__VITE_ASSET__pUjS5uYB__"